import { render, staticRenderFns } from "./ProjectsConfigure.vue?vue&type=template&id=b8054e12&"
import script from "./ProjectsConfigure.vue?vue&type=script&lang=js&"
export * from "./ProjectsConfigure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports